<template>
    <div>
        <header class="nav-top">
            <top-menu/>
        </header>
        <div class="sidebar" :style="sideBarStyle">
            <div class="sidebar-wrapper">
                <el-menu
                    router
                    :collapse="isCollapse"
                    :collapse-transition="false"
                    :default-active="letMenu"
                    class="el-menu-vertical-demo"
                    @open="handleOpen"
                    @close="handleClose">
                    <el-menu-item index="/cpsite/dash">
                        <i class="el-icon-data-analysis"></i>
                        <span slot="title">DASH</span>
                    </el-menu-item>
                    <el-submenu index="1">
                        <template slot="title">
                            <i class="el-icon-s-promotion"></i>
                            <span>SEND</span>
                        </template>
                        <el-menu-item index="/cpsite/send">{{ $strings('word/send') }}</el-menu-item>
                        <el-menu-item index="/cpsite/send-report">{{ $strings('word/send_report') }}</el-menu-item>
                        <el-menu-item index="/cpsite/trx">{{ $strings('word/send_detail') }}</el-menu-item>
                    </el-submenu>
                    <el-menu-item index="/cpsite/app">
                        <i class="el-icon-lollipop"></i>
                        <span slot="title">APP</span>
                    </el-menu-item>
                    <el-menu-item index="/cpsite/tpl">
                        <i class="el-icon-chat-line-round"></i>
                        <span slot="title">{{ $strings('word/templates') }}</span>
                    </el-menu-item>
                    <el-menu-item index="/cpsite/address">
                        <i class="el-icon-notebook-2"></i>
                        <span slot="title">{{ $strings('word/contract_groups') }}</span>
                    </el-menu-item>
                    <el-submenu index="2">
                        <template slot="title">
                            <i class="el-icon-bank-card"></i>
                            <span>BALANCE</span>
                        </template>
                        <el-menu-item index="/cpsite/pack">{{ $strings('word/rate_pack') }}</el-menu-item>
                        <el-menu-item index="/cpsite/balance">Balance</el-menu-item>
                    </el-submenu>
                </el-menu>
                <div class="sidebar-collapse" @click="toggleSidebar">
                    <el-tooltip class="item" effect="dark" :content="$strings('word/toggle_sidebar')" placement="right">
                        <i class="el-icon-menu" style="transform: rotate(45deg);"></i>
                    </el-tooltip>
                </div>
            </div>
        </div>
        <main class="main" :style="mainStyle">
            <router-view/>
        </main>
    </div>
</template>

<script>

import TopMenu from '@/components/topmenu';
import {GetItem, SaveItem} from "@/utils/storage";
import {STORAGE_KEY_TOGGLE_SIDEBAR} from "@/config/config";
import {EVENT_ROUTER_BACK, PubSubGlobal} from "../../utils/pubsub";

export default {
    name: "cpsite-home",
    components: {TopMenu},
    data() {
        return {
            isCollapse: false,
            letMenu: "/cpsite/cp"
        }
    },
    created() {
        this.isCollapse = GetItem(STORAGE_KEY_TOGGLE_SIDEBAR) === 'Y';
        PubSubGlobal.register(EVENT_ROUTER_BACK, this.refreshRouter);
    },
    mounted() {
        this.refreshRouter("");
    },
    computed: {
        sideBarStyle: function () {
            return this.isCollapse ? {width: '4em'} : {width: '16em'}
        },
        mainStyle: function () {
            return this.isCollapse ? {paddingLeft: '4em'} : {paddingLeft: '16em'};
        }
    },
    methods: {
        refreshRouter(router) {
            if (router.length > 0) {
                this.letMenu = router;
            } else {
                let pathName = window.location.hash.substr(1);
                if (pathName !== this.letMenu) {
                    this.letMenu = pathName
                }
            }
        },
        handleOpen(key, keyPath) {
            console.log(key, keyPath);
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath);
        },
        toggleSidebar() {
            this.isCollapse = !this.isCollapse;
            SaveItem(STORAGE_KEY_TOGGLE_SIDEBAR, this.isCollapse ? 'Y' : 'N')
        },
    }
}
</script>

<style lang="scss">
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
    border-bottom: none !important;
    font-weight: bold;
}
</style>

<style scoped lang="scss">

@import "src/assets/css/var";

$color-border-base: #dcdfe6;
$site_bar_width: 16em;

.nav-top {
    border-bottom: 1px solid $color-border-base;
    position: sticky;
    top: 0;
    left: 0;
    right: 0;
    background-color: white;
    z-index: 9;
}

.sidebar {
    position: fixed;
    top: 62px;
    bottom: 0;
    z-index: 1;
    left: 0;
    width: $site_bar_width;
    border-right: 1px solid $color-border-base;
}

.sidebar-wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;

    .el-menu-vertical-demo {
        flex-grow: 1;
        border-right: none;

        .el-menu-item.is-active {
            font-weight: bold;
            border-right: 3px solid $primary-color
        }
    }

    .sidebar-collapse {
        cursor: pointer;
        padding: 1.5em;
    }
}

.main {
    padding-left: $site_bar_width;
}
</style>